import { BotSparkle20Regular, Chat20Regular, ChevronRight20Regular, Document20Regular, PersonVoice20Regular } from '@/components/Icon'
import ActionButtonRow from './components/ActionButtonRow'
import ThreadsSection from './components/ThreadsSection'



export function renderSecondaryNavThreadSection(section, ctx) {
  const key = `${section.type}-${ctx.index}`

  if (section.type === 'newChatAction') {
    return (
      <ActionButtonRow
        key={key}
        Icon={Chat20Regular}
        label={section.label ?? 'New Chat'}
        onClick={ctx.onNewChat}
        active={!ctx.documentsActive && !ctx.doVoiceActive && !ctx.buildActive && !ctx.selectedThreadId}
      />
    )
  }

  if (section.type === 'documentsAction') {
    return (
      <ActionButtonRow
        key={key}
        Icon={Document20Regular}
        label={section.label ?? 'Documents'}
        onClick={ctx.onDocuments}
        active={Boolean(ctx.documentsActive)}
      />
    )
  }

  if (section.type === 'doVoiceAction') {
    return (
      <ActionButtonRow
        key={key}
        Icon={PersonVoice20Regular}
        label={section.label ?? 'DO Voice'}
        onClick={ctx.onDoVoice}
        active={Boolean(ctx.doVoiceActive)}
      />
    )
  }

  if (section.type === 'navAction') {
    return (
      <ActionButtonRow
        key={key}
        Icon={BotSparkle20Regular}
        label={section.label ?? 'Agents'}
        trailingIcon={section.trailingChevron ? ChevronRight20Regular : undefined}
        onClick={() => ctx.onNavAction?.(section)}
        plain
      />
    )
  }

  if (section.type === 'threadsList') {
    return (
      <ThreadsSection
        key={key}
        threads={ctx.threads}
        selectedThreadId={ctx.selectedThreadId}
        onSelectThread={ctx.onThreadSelect}
        onThreadMenuAction={ctx.onThreadMenuAction}
        onRenameThread={ctx.onRenameThread}
      />
    )
  }

  return null
}
